import React from 'react';

function Home() {
  return (
    <div className="text-center">
      <h1 className="text-4xl font-bold mb-4">Welcome to Eccentric Stylist</h1>
      <p className="text-xl">Coming soon!</p>
    </div>
  );
}

export default Home;

